import '../../components/ProjectList.css'
import {useFirestore} from "../../hooks/useFirestore"
import {useAuthcontext} from "../../hooks/useAuthcontext"
import { useNavigate } from 'react-router-dom';

export const ProjectSummary = ({project}) => {
  const {deleteDocument} = useFirestore('projects')
  const { user } = useAuthcontext()
  let navigate = useNavigate();

  const handleClick = () => {
    deleteDocument(project.id)
    navigate('/');
  }
  return (
    <div className='project-summary'>
        <h2 className='page-title'>{project.name}</h2>
        <p className='createdBy'>By {project.createdBy.displayName}</p>
        <p className='due-date'>
            Project due by {project.dueDate.toDate().toDateString()}
        </p>
        <p className='details'>{project.details}</p>
        <h4>Project is assigned to:</h4>
        <div className='assigned-users'>
          
        {project.assignedUsersList.map((user) => (
            <div key={user.id} className='projectSummary'>
                 {user.display}
            </div>
        ))}
        </div>
        {user.uid === project.createdBy.id && (
          <button className='btn completeBtn' onClick={handleClick}>Mark as Complete</button>
        )}
    </div>
  )
}
